//place here your custom javascript, you're free to create all the js files you need

document.addEventListener('DOMContentLoaded', function () {
  window.dataLayer = window.dataLayer || [];
  const buttons = [
    ...document.querySelectorAll('.iWishAddColl'),
    ...document.querySelectorAll('.iWishAdd')
  ];
  buttons.forEach((button) => updateWishlistDataLayer(button));
});

function updateWishlistDataLayer(button) {
  const product = JSON.parse(button.getAttribute('data-product-details'));
  const variant = product?.variants[0] || {};
  const collection = JSON.parse(button.getAttribute('data-collection'));
  const discount = JSON.parse(button.getAttribute('data-discount'));

  button.addEventListener('click', function () {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_wishlist',
      ecommerce: {
        currency: Shopify.currency.active,
        value: variant?.price,
        items: [
          {
            item_id: variant?.sku,
            item_name: variant?.name,
            item_category: collection?.title,
            coupon: discount?.title,
            discount: discount?.value,
            index: 0,
            item_brand: product?.vendor,
            item_list_name: collection?.title,
            item_variant: variant?.title,
            price: variant?.price,
            quantity: '1'
          }
        ]
      }
    });
  });
}
const bundleProducts = [];

function bundleBuilder() {
  const addToBundleButtons = document.querySelectorAll('.addToBundle');
  const addBundleToCartButton = document.querySelector('.add-to-cart');
  const bundleMaxElements = window.bundleBuilder.numberOfProductsInBundle;

  function handleAddToBundleButtons() {
    addToBundleButtons.forEach((button) => {
      if (bundleProducts.length != bundleMaxElements) {
        button.classList.remove('disabled');
      }
      button.removeEventListener('click', function () {
        manageBundleButtons(button);
      });

      button.addEventListener('click', function () {
        manageBundleButtons(button);
      });
    });
  }

  function manageBundleButtons(button) {
    const variant = JSON.parse(button.getAttribute('data-variant-details'));
    addProductToBundle(variant);
    resetBundleBox();
    renderBundleItems();
    updateButtonStatus();
  }

  function addProductToBundle(variant) {
    bundleProducts.push({
      variantId: variant?.id,
      variantSku: variant?.sku,
      variantName: variant?.name,
      variantTitle: variant?.title,
      variantPrice: variant?.price,
      imageSrc: variant?.featured_image?.src,
      quantity: '1'
    });
  }

  function resetBundleBox() {
    const bundleBox = document.querySelector('.selected-products-container');
    bundleBox.innerHTML = '';
  }

  function renderBundleItems() {
    bundleProducts.forEach((selectedProduct, index) => {
      const bundleElement = document.getElementById(`placeholder-${index + 1}`);
      if (bundleElement) {
        bundleElement.classList.add('hide-wrapper');
      }
      createBundleProductCard(selectedProduct, index);
      handleRemoveFromBundle(index);
    });
  }

  function createBundleProductCard(selectedProduct, index) {
    const div = document.createElement('div');
    div.className = `main-wrapper-images img-wrapper-box product-${index + 1}`;

    const removeDiv = document.createElement('div');
    removeDiv.id = `remove-pdp-${index + 1}`;
    removeDiv.className = `remove-pdp selectedProduct-${index + 1}`;
    removeDiv.setAttribute('data-index', index);
    removeDiv.innerHTML = window.bundleBuilder.closeIcon;

    const img = document.createElement('img');
    img.src = selectedProduct.imageSrc;
    img.alt = selectedProduct.variantName;
    img.className = '';

    div.appendChild(removeDiv);
    div.appendChild(img);
    const bundleBox = document.querySelector('.selected-products-container');
    bundleBox.appendChild(div);
  }

  function handleRemoveFromBundle(index) {
    const removeButton = document.querySelector(`#remove-pdp-${index + 1}`);
    removeButton.addEventListener('click', function (e) {
      bundleProducts.splice(index, 1);
      resetBundleBox();
      renderBundleItems();
      const bundleElements = document.querySelectorAll(
        '[id^="placeholder-"].hide-wrapper'
      );
      if (bundleElements.length > 0) {
        bundleElements[bundleElements.length - 1].classList.remove(
          'hide-wrapper'
        );
      }
      updateButtonStatus();
    });
  }

  function updateButtonStatus() {
    const isBundleEmpty = bundleProducts.length === 0;
    const isBundleFull = bundleProducts.length === bundleMaxElements;

    addBundleToCartButton.classList.toggle('disabled', isBundleEmpty);
    addBundleToCartButton.disabled = isBundleEmpty;

    addToBundleButtons.forEach((button) => {
      button.classList.toggle('disabled', isBundleFull);
      button.disabled = isBundleFull;
    });
  }

  function handleAddToCartButton() {
    addBundleToCartButton.addEventListener('click', function () {
      const items = bundleProducts.map((product) => {
        return {
          id: product.variantId,
          quantity: product.quantity
        };
      });

      const data = { items };
      addToCart(data).finally(() => {
        bundleProducts.length = 0;
        resetBundleBox();
        renderBundleItems();
        updateButtonStatus();

        const bundleElements = document.querySelectorAll(
          '[id^="placeholder-"].hide-wrapper'
        );
        bundleElements.forEach((element) => {
          element.classList.remove('hide-wrapper');
        });
      });
    });
  }

  handleAddToBundleButtons();
  handleAddToCartButton();
}

document.addEventListener('DOMContentLoaded', function () {
  const bundleElement = document.querySelector('.shopify-section--main-bundle');
  if (bundleElement) {
    bundleElement[0].classList.add('processed');
    bundleBuilder();
  }
});

// custom add to cart
async function addToCart(data) {
  await startLoading();

  const sectionsToBundle = await prepareBundledSections();
  data['sections'] = sectionsToBundle.join(',');

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(data)
  })
    .then((response) => handleResponse(response, data))
    .catch((error) => handleError(error));
}

async function startLoading() {
  document.documentElement.dispatchEvent(
    new CustomEvent('theme:loading:start', { bubbles: true })
  );
}

async function endLoading() {
  document.documentElement.dispatchEvent(
    new CustomEvent('theme:loading:end', { bubbles: true })
  );
}

async function prepareBundledSections() {
  let sectionsToBundle = [];
  document.documentElement.dispatchEvent(
    new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    })
  );
  return sectionsToBundle;
}

async function handleResponse(response, data) {
  const responseJson = await response.json();
  await endLoading();

  if (response.ok) {
    if (
      window.themeVariables.settings.cartType === 'page' ||
      window.themeVariables.settings.pageType === 'cart'
    ) {
      return (window.location.href = `${Shopify.routes.root}cart`);
    }

    const cartContent = await (
      await fetch(`${Shopify.routes.root}cart.js`)
    ).json();
    cartContent['sections'] = responseJson['sections'];

    document.documentElement.dispatchEvent(
      new CustomEvent('variant:add', {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty('items')
            ? responseJson['items']
            : [responseJson],
          cart: cartContent,
          onSuccessDo: data.on_success
        }
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          onSuccessDo: data.on_success,
          cart: cartContent
        }
      })
    );
  } else {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:error', {
        bubbles: true,
        detail: {
          error: responseJson['description']
        }
      })
    );
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }
}

async function handleError(error) {
  console.error('Error:', error);
  await endLoading();

  document.documentElement.dispatchEvent(
    new CustomEvent('cart:error', {
      bubbles: true,
      detail: {
        error: error.message
      }
    })
  );

  document.dispatchEvent(new CustomEvent('cart:refresh'));
}

function addItemsToCart() {
  const extraFields = {
    _customizationSource: parsedSettings.value.customizationSource
  };

  if (preorderStatus.value.preorder && preorderStatus.value.preorderDate) {
    extraFields._preorder_date = preorderStatus.value.preorderDate;
  }

  const selectionProperties = generateSelectionProperties(
    selectedOptions.value,
    extraFields
  );

  const items = [
    {
      id: selectedOptions.value.variation.id,
      quantity: 1,
      properties: selectionProperties
    }
  ];

  if (selectedOptions.value.customizationVariant) {
    items.push({
      id: selectedOptions.value.customizationVariant.id,
      quantity: 1,
      properties: selectionProperties
    });
  }

  if (selectedOptions.value.selectedPatchId) {
    items.push({
      id: selectedOptions.value.selectedPatchId,
      quantity: 1,
      properties: selectionProperties
    });
  }

  const data = { items, selectionProperties };

  try {
    isAddingToCart.value = true;
    addToCart(data).finally(() => {
      closeDrawer();
      resetCustomization();
      isAddingToCart.value = false;
    });
  } catch (e) {
    console.error(e);
  }
}

// handle download accordions show/hide in product page on variant change
document.addEventListener('DOMContentLoaded', function () {
  const variantId = JSON.parse(document.querySelector('script[data-variant]')?.textContent)?.id;
  if (!variantId) return
  const selectors = ['.specifics-row[data-variant-id]', '.download-link[data-variant-id]'];
  selectors.forEach(selector => {
    handleVariantSpecificInformation(selector, variantId);
  });

    document.addEventListener('variant:change', function (event) {
      const variantId = event.detail.variant.id;
      selectors.forEach((selector) => {
        handleVariantSpecificInformation(selector, variantId);
      });
    });
});

function handleVariantSpecificInformation(selector, variantId) {
  const elements = document.querySelectorAll(selector);
  if (!elements) return;

  Array.from(elements).forEach((element) => {
    element.dataset.variantId.toString() === variantId.toString() ? element.removeAttribute('hidden') : element.setAttribute('hidden', true);
  });
}

// Accessibility: Slideshow
document.addEventListener('DOMContentLoaded', function () {
  function handleSlideshowAccessibility() {
    const slideshows = document.querySelectorAll('.slideshow');
    slideshows.forEach((slideshow) => {
      const slides = slideshow.querySelectorAll('.slideshow__slide');
      const dots = slideshow.querySelectorAll('.page-dots button');
      dots.forEach((dot, index) => {
        dot.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            if (dot.getAttribute('aria-current') === 'true') {
              const visibleSlide = Array.from(slides).find(slide => slide.classList.contains('is-selected'));
              if (visibleSlide) {
                const ctas = visibleSlide.querySelector('.slideshow__slide-content').querySelectorAll('.button');
                ctas[0].focus();
              }
            }
            else {
              dot.click();
            }
          }
        });
      });
    });
  }

  handleSlideshowAccessibility();
})
